<template>
  <div>
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <span>{{ carstore.car.plate_code }}</span>
          Araç KM Geçmişi
          </div>
         <button v-if="carstore.car.in_service == 0" @click="newCarKM()" class="btn btn-sm btn-primary">Yeni Kayıt</button>
      </div>
      <div class="card-body p-0">
        <div class="border-top border-bottom p-1">
          <div class="row">
            <div class="col-sm-2">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold"
                  >Başlangıç</small
                >
                <flat-pickr
                  class="form-control"
                  v-model="datasource.filter.start_date"
                  :config="{
                    enableTime: true,
                    altFormat: 'd.m.Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    locale: 'tr',
                  }"
                />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <small class="text-sm text-uppercase font-semibold"
                  >Bitiş</small
                >
                <flat-pickr
                  class="form-control"
                  v-model="datasource.filter.end_date"
                  :config="{
                    enableTime: true,
                    altFormat: 'd.m.Y',
                    altInput: true,
                    dateFormat: 'Y-m-d',
                    locale: 'tr',
                  }"
                />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group mt-2">
                <button class="btn btn-primary" @click="getCarHistory()">
                  Uygula
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="firstlast-padding">
          <b-table
            ref="table_km_history"
            responsive
            striped
            small
            hover
            select-mode="single"
            @row-selected="setTableRow"
            :items="datasource.kmHistory"
            :fields="datasource.table.fields"
            :tbody-tr-class="rowClass"
            class="mb-0 align-top"
            show-empty
          >
            <template #cell(user_id)="data">
              <div v-if=" data.item.user_item != null ">
                <span class="text-primary" @click="setCarKM(data.item)">{{ data.item.user_item.user_namesurname }}</span>
              </div>
            </template>
            <template #cell(received_date)="data">
              <div v-if="data.value != null && data.value !='' ">
                {{ moment(data.value).format('DD.MM.YYYY HH:mm') }}
              </div>
            </template>
            <template #cell(received_km)="data">
              <div>
                {{ data.value }}
              </div>
            </template>
            <template #cell(delivered_date)="data">
              <div v-if="data.value != null && data.value!='' ">
                {{ moment(data.value).format('DD.MM.YYYY HH:mm') }}
              </div>
            </template>
            <template #cell(delivered_km)="data">
              <div>
                {{ data.value }}
              </div>
            </template>    
            <template #cell(created_props)="data">
              <div>{{ moment(data.value.created_at).format('DD.MM.YYYY HH:mm') }}</div>
              <div>{{ data.value.created_by_name }}</div>
            </template>
            <template #empty>
              <div class="pt-3 pb-3 text-center">
                Listelenecek bir kayıt bulunmuyor.
              </div>
            </template>
          </b-table>
        </div>

      </div>

      <b-modal v-model="datasource.showcarmodal" hide-footer centered size="lg">
        <template #modal-title>
          <span v-if="carstore.car.drive_user_id == 0">Araç Alımı</span>
          <span v-else>Araç Teslimi</span>
          <span class="ml-1">{{ carstore.car.plate_code }}</span>
        </template>
        <div class="d-block">
          <div class="row mb-05">
            <div class="col-sm-4 text-uppercase">Marka Model</div>
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                :value="carstore.car.brand_name + ' ' + carstore.car.model_name"
                disabled
              />
            </div>
          </div>
          <div class="row mb-05">
            <div class="col-sm-4 text-uppercase">Güncel KM</div>
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                :value="carstore.car.current_km"
                disabled
              />
            </div>
          </div>
          <div v-if="carstore.car_km.car_km_id == 0">
            <div class="row mb-05">
              <div class="col-sm-4 text-uppercase">Alım Tarihi</div>
              <div class="col-sm-8">
                <flat-pickr
                  class="form-control"
                  v-model="carstore.car_km.received_date"
                  :config="{
                    enableTime: true,
                    altFormat: 'd.m.Y H:i',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: 'tr',
                  }"
                />
              </div>
            </div>
            <div class="row mb-05">
              <div class="col-sm-4 text-uppercase">Teslim Alan</div>
              <div class="col-sm-8">
                <v-select
                  v-model="carstore.car_km.user_id"
                  :options="datasource.users"
                  :reduce="(option) => option.user_id"
                  label="user_namesurname"
                  :searchable="true"
                  :clearable="false"
                />
              </div>
            </div>
            <div class="row mb-05">
              <div class="col-sm-4 text-uppercase">Teslim Alındığı KM</div>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="carstore.car_km.received_km"
                />
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row mb-05">
              <div class="col-sm-4 text-uppercase">Alındığı KM</div>
              <div class="col-sm-8">
                <input
                  class="form-control"
                  :value="carstore.car_km.received_km"
                  readonly
                />
              </div>
            </div>

            <div class="row mb-05">
              <div class="col-sm-4 text-uppercase">Teslim Edildiği KM</div>
              <div class="col-sm-8">
                <input
                  type="number"
                  class="form-control"
                  v-model="carstore.car_km.delivered_km"
                />
              </div>
            </div>

            <div class="row mb-05">
              <div class="col-sm-4 text-uppercase">Teslim Edildiği Tarih</div>
              <div class="col-sm-8">
                <flat-pickr
                  class="form-control"
                  v-model="carstore.car_km.delivered_date"
                  :config="{
                    enableTime: true,
                    altFormat: 'd.m.Y H:i',
                    altInput: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: 'tr',
                  }"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <button @click="saveCarKMItem()" class="btn btn-primary">
              Kaydet
            </button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import StatusBadge from "@/views/common/StatusBadge.vue";
import { VueAutosuggest } from "vue-autosuggest";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { tr } from "flatpickr/dist/l10n/tr.js";
import api from "@/service/api";
import utils from "@/service/utils";
import _ from "lodash";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";

export default {
  components: {
    StatusBadge,
    VueAutosuggest,
    vSelect,
    flatPickr,
  },
  data() {
    return {
      datasource: {
        filter: {
          start_date: null,
          end_date: null,
        },
        kmHistory: [],
        showcarmodal: false,
        table: {
          fields: [
            {
              key: "user_id",
              label: "Kullanıcı",
              sortable: true,
              selected: true,
            },
            {
              key: "received_date",
              label: "Teslim Alındığı Tarih",
              sortable: true,
              selected: true,
            },
            {
              key: "received_km",
              label: "Teslim Alındığı KM",
              sortable: true,
              selected: true,
            },
            {
              key: "delivered_date",
              label: "Teslim Edildiği Tarih",
              sortable: true,
              selected: true,
            },
            {
              key: "delivered_km",
              label: "Teslim Edildiği KM",
              sortable: true,
              selected: true,
            },
            {
              key: "created_props",
              label: "Oluşturulma Tarihi",
              sortable: true,
              selected: true,
            },
          ],
          selected: null,
        },
      },
    };
  },
  methods: {
    ...mapActions(["saveCarKM"]),
    getCarDetail() {
      let uniq = this.$route.query.uniq;
      if (!utils.isNullOrEmpty(uniq)) {
        api.action("GetCarDetail", { uniq: uniq }).then((q) => {
          if (q.success == false) {
            this.$router.push("/carstracking/list");
            utils.notificationToast("warning", "Bilgi", "Geçersiz bilgi.");
            return;
          } else {
            this.carstore.car = q.data.car;
            this.getCarHistory();
          }
        });
      }
    },
    getUsers() {
      api.action("getUsers").then((q) => {
        if (q.success) {
          this.datasource.users = q.data;
        }
      });
    },
    getCarHistory()
    {
     let uniq = this.$route.query.uniq;
      api.action('getCarHistory',{ uniq:uniq,...this.datasource.filter }).then( (q) => 
      {
        if(!q.success) { utils.notificationToast('warning',"Bilgi",q.message); return; }
        this.datasource.kmHistory = q.data;
      })
    },
    toggleCarStateModal() {
      this.datasource.showcarmodal = !this.datasource.showcarmodal;
    },
    setCarKM(v)
    {
      this.carstore.car_km = v;
      console.log('v',v);
      if( v.received_date == null || v.delivered_date == null )
      {
      this.toggleCarStateModal();
      }

    },
    newCarKM()
    {
      this.carstore.car_km.car_km_id = 0;
      this.toggleCarStateModal();
    },
    saveCarKMItem()
    {
      this.saveCarKM().then(q=>{
        if(q.success)
        {
          this.getCarHistory();
          this.carstore.car = data.car;
          this.toggleCarStateModal();
        }
      });
    },
    setTableRow(v) {},
    rowClass(item, type) {
      if (!item || type !== "row") {
        return;
      }
    },
    moment(v) {
      return moment(v);
    },
  },
  created() {
    let uniq = this.$route.query.uniq;
    if (utils.isNullOrEmpty(uniq)) {
      this.$router.push("/not-found");
      return;
    }

    this.datasource.filter.start_date = utils
      .moment()
      .add(-30, "days")
      .format("YYYY-MM-DD");
    this.datasource.filter.end_date = utils
      .moment()
      .add(7, "days")
      .format("YYYY-MM-DD");
    this.getCarDetail();
    this.getUsers();
  },
  computed: {
    ...mapState({
      sf: (state) => state.sf,
      global: (state) => state.global,
      carstore: (state) => state.car,
    }),
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
